import { useRef } from "react";
import useSplashAnimation from "../../hooks/useSplashAnimation";
import logo from "../../assets/logo-nobg.png";
import "../../styles/splash.css";

/**
 * Boot-time splash screen. Rendered once above the app shell on first
 * load; unmounts itself via onFinish once the focus-pull/exit timeline
 * completes. See useSplashAnimation for the actual GSAP sequence.
 */
export default function SplashScreen({ appRef, onFinish }) {
  const glowRef = useRef(null);
  const ringRef = useRef(null);
  const flashRef = useRef(null);
  const brandZoomRef = useRef(null);
  const shineRef = useRef(null);

  useSplashAnimation({ glowRef, ringRef, flashRef, brandZoomRef, shineRef, appRef, onFinish });

  return (
    <div className="splash-screen" aria-hidden="true">
      <div ref={glowRef} className="splash-glow" />
      <div ref={ringRef} className="splash-ring" />
      <div ref={flashRef} className="splash-flash" />
      <div ref={brandZoomRef} className="splash-brand-zoom">
        <div className="splash-shine-wrap">
          <img src={logo} alt="Smart Connect Electrical" />
          <div ref={shineRef} className="splash-shine" />
        </div>
      </div>
    </div>
  );
}
